export default function (query) {
    const queryString = []
    for (const queryParam in query)
        if (query.hasOwnProperty(queryParam)) {
            queryString.push(encodeURIComponent(queryParam) + "=" + encodeURIComponent(query[queryParam]))
        }
    return queryString.join("&")
}
